import {action, observable} from "mobx";
import equipmentService from "../services/equipmentService";
import appStore from "./appStore";
import {message} from "antd";

class equipmentStore {
    @observable equipmentTypes = [];
    @observable equipments = [];

    @action setEquipmentTypes = (data = []) => {
        this.equipmentTypes = data;
    };
    @action getEquipmentTypeById = id => {
        return this.equipmentTypes.find(item => item?._id === id);
    };
    //#region Equipment Types
    @action listEquipmentTypes = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.listEquipmentTypes(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action createEquipmentType = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.createEquipmentType(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        message.success("Ekipman Tipi Oluşturuldu");
        return true;
    };

    @action updateEquipmentType = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.updateEquipmentType(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        message.success("Ekipman Tipi Güncellendi");
        return true;
    };

    @action deleteEquipmentType = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.deleteEquipmentType(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        message.success("Ekipman Tipi Silindi");
        return true;
    };

    //#endregion

    //#region Equipments
    @action listEquipments = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.listEquipments(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action listAllEquipments = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.listAllEquipments(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        this.equipments = resultOfRequest.data.data.result;
        return resultOfRequest.data;
    };

    @action getEquipment = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.getEquipment(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action createEquipment = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.createEquipment(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        message.success("Ekipman Oluşturuldu");
        return true;
    };

    @action updateEquipment = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.updateEquipment(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        message.success("Ekipman Güncellendi");
        return true;
    };

    @action deleteEquipment = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.deleteEquipment(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        message.success("Ekipman Silindi");
        return true;
    };
    //#endregion

    //#region Courier Equipments
    @action listCourierEquipments = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.listCourierEquipments(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
    @action exportCourierEquipments = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.exportCourierEquipments(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
    @action courierEquipmentDetail = async params => {
        const resultOfRequest = await equipmentService.courierEquipmentDetail(params);
        return resultOfRequest.data;
    };

    @action assignEquipmentToMultipleCouriers = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.assignEquipmentToMultipleCouriers(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        message.success("Ekipmanlar Kuryelere Atandı");
        return resultOfRequest.data;
    };
    @action returnEquipmentFromCourier = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentService.returnEquipmentFromCourier(params);
        await appStore.setLoading(false);
        if (resultOfRequest?.data?.success === false) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        message.success("Ekipman İade Alındı");
        return true;
    };

    @action completeEquipmentAssignment = async params => {
        try {
            const resultOfRequest = await equipmentService.completeEquipmentAssignment(params);

            if (resultOfRequest?.data?.success !== true) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            message.success("Ekipman Atama Süreci Tamamlandı");
            return resultOfRequest.data;
        } catch (error) {
            message.error(error.message);
            return false;
        }
    };

    @action rejectCourierEquipmentContract = async params => {
        try {
            const resultOfRequest = await equipmentService.rejectCourierEquipmentContract(params);

            if (resultOfRequest?.data?.success !== true) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            message.success("Ekipman Sözleşmesi Reddedildi");
            return resultOfRequest.data;
        } catch (error) {
            message.error(error.message);
            return false;
        }
    };

    @action deleteWaitingAssignmentEquipment = async params => {
        try {
            const resultOfRequest = await equipmentService.deleteWaitingAssignmentEquipment(params);

            if (resultOfRequest?.data?.success !== true) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            message.success("Atama Bekleyen Kurye Ekipmanı Silindi");
            return resultOfRequest.data;
        } catch (error) {
            message.error(error.message);
            return false;
        }
    };
    //#endregion
}

export default new equipmentStore();
